import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // Enable dev tools in development
  defaultErrorComponent: ({ error }: { error: Error }) => {
    return (
      <div>
        <h1>Error: {error.message}</h1>
      </div>
    );
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
